<template>
  <div>
    <multiselect
      :value="getCurrentTagList"
      :options="options"
      :multiple="true"
      label="name"
      @input="updateTagStates"
      @select="addTagToStore"
      @remove="updateTags"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import Multiselect from "vue-multiselect"
import siteConfig from "@/utils/siteConfig"

export default {
  components: { Multiselect },
  data() {
    return {
      selected: [],
      options: [],
    }
  },
  computed: {
    ...mapGetters("module", ["getCurrentTagList", "getOriginalTagList"]),
  },
  methods: {
    ...mapActions("module", [
      "SET_CURRENT_TAG_LIST",
      "SET_ADDED_TAG_LIST",
      "SET_DELETED_TAG_LIST",
    ]),
    updateTagStates() {
      const deletedTags = []
      for (let i = 0; i < this.getOriginalTagList.length; i++) {
        if (
          !this.findElementInArray(
            this.getOriginalTagList[i].name,
            this.getCurrentTagList.map(item => item.name)
          )
        ) {
          deletedTags.push(this.getOriginalTagList[i])
        }
      }
      this.SET_DELETED_TAG_LIST(deletedTags)
      const addedTags = []

      for (let i = 0; i < this.getCurrentTagList.length; i++) {
        if (
          !this.findElementInArray(
            this.getCurrentTagList[i].name,
            this.getOriginalTagList.map(item => item.name)
          )
        ) {
          addedTags.push(this.getCurrentTagList[i])
        }
      }
      this.SET_ADDED_TAG_LIST(addedTags)
    },
    findElementInArray(element, array) {
      for (let i = 0; i < array.length; i++) {
        if (array[i] === element) {
          return true
        }
      }
      return false
    },
    addTagToStore(obj) {
      const currentTagList = this.getCurrentTagList
      currentTagList.push(obj)
      this.SET_CURRENT_TAG_LIST(currentTagList)
      // /////////////////////////
      this.updateTagStates()
    },
    updateTags(tag) {
      const currentTagList = this.getCurrentTagList
      const index = currentTagList.indexOf(tag)
      if (index > -1) {
        currentTagList.splice(index, 1)
      }
      this.SET_CURRENT_TAG_LIST(currentTagList)
      this.$emit("tagsUpdated", this.selected)
    },

    populateQTags() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}qtags/?pagination=false`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        const tags = res.data.items
        this.options = tags.map(item => ({ id: item.id, name: item.name }))
      })
    },
  },
  mounted() {
    this.populateQTags()
  },
}
</script>

<style></style>
